// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".padded-text__content[data-v-39718b6c]{white-space:pre-line;padding:0;margin:0}.padded-text[data-v-39718b6c] :not(:last-child){margin-bottom:16px!important}@media(max-width:599.9px){.padded-text[data-v-39718b6c] :not(:last-child){margin-bottom:12px!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
